exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-wrapper[data-v-ea26eeba]{display:inline-block;margin:10px 1px\n}\n.button-wrapper button[data-v-ea26eeba]{margin:0\n}", ""]);

// exports
